/**
 * User Management Hooks
 *
 * These hooks provide functionality for managing user profiles,
 * user data, and user-related operations.
 */
import { useAuthContext } from './core-hooks';
/**
 * Hook to get current user profile
 */
export function useCurrentUser() {
    const { userProfile } = useAuthContext();
    return userProfile;
}
/**
 * Hook to get current user ID
 */
export function useCurrentUserId() {
    const { userProfile } = useAuthContext();
    return userProfile?.id || null;
}
/**
 * Hook to get current user email
 */
export function useCurrentUserEmail() {
    const { userProfile } = useAuthContext();
    return userProfile?.email || null;
}
/**
 * Hook to get current user name
 */
export function useCurrentUserName() {
    const { userProfile } = useAuthContext();
    return userProfile?.name || null;
}
/**
 * Hook to get current user permissions
 */
export function useCurrentUserPermissions() {
    const { userProfile } = useAuthContext();
    return userProfile?.permissions || [];
}
/**
 * Hook to get current user roles
 */
export function useCurrentUserRoles() {
    const { userProfile } = useAuthContext();
    return userProfile?.roles || [];
}
/**
 * Custom hook for user management (wrapper around auth context)
 * Provides a convenient interface for user-related operations
 */
export function useUser() {
    const { userProfile, isLoading, isAuthenticated } = useAuthContext();
    return {
        user: userProfile,
        userId: userProfile?.id || null,
        userEmail: userProfile?.email || null,
        userName: userProfile?.name || null,
        userPermissions: userProfile?.permissions || [],
        userRoles: userProfile?.roles || [],
        isLoading,
        isAuthenticated,
    };
}
